import React from 'react'
import Layout, { Container } from '../components/layout'

const TicketList = () => {
  return (
    <Layout>
      <Container>

        <section className="px-4 py-0 bg-gray-100">
          <div className="flex justify-between px-4 py-0 pt-4">
            <div className="flex text-sm text-black">
              <p className="font-medium">Total : </p>
              <p className="font-bold"> 1246 Assignees</p>
            </div>
            <div className="px-4 py-2 border bg-white border-gray-100 rounded-full flex">
              <p className="text-sm">Filter</p>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.9893 16.7151C12.4566 16.7151 11.0117 15.8849 10.2294 14.5419C9.81427 13.8582 9.59873 13.0605 9.59873 12.2384C9.59873 9.77209 11.5705 7.76163 13.9893 7.76163C16.4081 7.76163 18.3799 9.77209 18.3799 12.2384C18.3799 13.0605 18.1564 13.8582 17.7413 14.55C16.9669 15.8849 15.53 16.7151 13.9893 16.7151ZM13.9893 8.98256C12.2251 8.98256 10.7962 10.4395 10.7962 12.2384C10.7962 12.8326 10.9558 13.4105 11.2592 13.907C11.8339 14.8919 12.8797 15.4942 13.9893 15.4942C15.1229 15.4942 16.1447 14.9081 16.7194 13.9151C17.0228 13.4105 17.1825 12.8326 17.1825 12.2384C17.1825 10.4395 15.7535 8.98256 13.9893 8.98256Z"
                  fill="#ABBBC8"
                />
                <path
                  d="M15.4102 12.8325H12.5763C12.249 12.8325 11.9776 12.5558 11.9776 12.2221C11.9776 11.8884 12.249 11.6116 12.5763 11.6116H15.4102C15.7375 11.6116 16.009 11.8884 16.009 12.2221C16.009 12.5558 15.7375 12.8325 15.4102 12.8325Z"
                  fill="#ABBBC8"
                />
                <path
                  d="M13.9893 14.3058C13.662 14.3058 13.3906 14.0291 13.3906 13.6953V10.814C13.3906 10.4802 13.662 10.2035 13.9893 10.2035C14.3166 10.2035 14.588 10.4802 14.588 10.814V13.7035C14.588 14.0372 14.3246 14.3058 13.9893 14.3058Z"
                  fill="#ABBBC8"
                />
                <path
                  d="M9.23944 18.75C8.85627 18.75 8.47309 18.6523 8.12983 18.457C7.41935 18.05 6.99626 17.3174 6.99626 16.4953V12.1407C6.99626 11.7337 6.73283 11.1151 6.47737 10.7977L3.44388 7.54999C2.94096 7.02092 2.5498 6.13373 2.5498 5.48257V3.58604C2.5498 2.27558 3.52371 1.25 4.76106 1.25H15.4102C16.6316 1.25 17.6214 2.25932 17.6214 3.50467V5.31162C17.6214 6.16627 17.1265 7.12677 16.6475 7.63142L15.2106 8.92558C15.0669 9.05581 14.8674 9.10463 14.6758 9.06393C14.4602 9.00696 14.2288 8.98256 13.9893 8.98256C12.2251 8.98256 10.7962 10.4395 10.7962 12.2384C10.7962 12.8326 10.9558 13.4105 11.2591 13.9151C11.5146 14.3465 11.8578 14.7047 12.257 14.957C12.4326 15.071 12.5443 15.2663 12.5443 15.4779V15.7547C12.5443 16.3977 12.1612 17.3012 11.5225 17.6837L10.4209 18.4082C10.0617 18.6361 9.64657 18.75 9.23944 18.75ZM4.76904 2.47093C4.20226 2.47093 3.75522 2.9593 3.75522 3.58604V5.48257C3.75522 5.77559 3.9947 6.37792 4.31402 6.7035L7.38742 10C7.79455 10.5128 8.20167 11.3837 8.20167 12.1488V16.5035C8.20167 17.0407 8.56888 17.3093 8.72056 17.3989C9.06382 17.5942 9.47095 17.5861 9.78228 17.3907L10.8999 16.6581C11.1154 16.5279 11.331 16.1128 11.3469 15.8198C10.9079 15.4861 10.5247 15.0546 10.2373 14.5663C9.82219 13.8744 9.59867 13.0768 9.59867 12.2628C9.59867 9.79654 11.5704 7.78607 13.9892 7.78607C14.2128 7.78607 14.4363 7.80235 14.6438 7.83491L15.8253 6.76863C16.0967 6.48374 16.432 5.80815 16.432 5.32791V3.52091C16.432 2.95114 15.977 2.48723 15.4182 2.48723H4.76904V2.47093Z"
                  fill="#ABBBC8"
                />
              </svg>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-2 gap-x-0.5 px-4 mt-8 sm:px-0 lg:mt-16 sm:grid-cols-2 lg:grid-cols-4 xl:gap-4">
            <div class="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow ">
              <div className="flex items-center justify-start pb-2">
                <div className="svg">
                  <svg
                    width="44"
                    height="44"
                    viewBox="0 0 44 44"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_3308_397)">
                      <rect width="44" height="44" rx="12" fill="#EBF9F5" />
                      <path
                        d="M29.1021 18.7074C28.8792 16.2798 27.4757 14.1273 25.3642 12.9745C23.2525 11.8217 20.7135 11.8217 18.6021 12.9745C16.4907 14.1275 15.0871 16.28 14.8642 18.7074C13.7548 18.9472 12.8175 19.6968 12.3261 20.7368C11.8348 21.7768 11.8451 22.9898 12.3541 24.021C12.8629 25.0522 13.813 25.7853 14.9263 26.0056C15.2016 27.7085 16.0621 29.2566 17.3544 30.3744C18.6467 31.4922 20.287 32.1071 21.9834 32.1099H23.0173C23.6803 32.1099 24.3161 31.8418 24.7849 31.3649C25.2537 30.8881 25.5169 30.2412 25.5169 29.5667C25.5169 28.8921 25.2537 28.2452 24.7849 27.7682C24.3161 27.2913 23.6803 27.0234 23.0173 27.0234C22.3544 27.0234 21.7186 27.2913 21.2498 27.7682C20.781 28.2452 20.5176 28.8921 20.5176 29.5667V30.3346C19.4105 30.026 18.4227 29.3801 17.687 28.4834C16.9513 27.5868 16.5031 26.4826 16.4025 25.3192C16.4775 21.1322 16.4825 19.7961 16.3845 19.2701H16.3843C16.407 17.2351 17.495 15.3668 19.2386 14.369C20.9823 13.3713 23.1167 13.3959 24.8379 14.4335C26.559 15.471 27.6051 17.3639 27.5826 19.3991V19.4438C27.4715 25.4928 27.5181 25.5506 27.8024 25.8479H27.8022C27.9505 25.9987 28.1511 26.0838 28.3607 26.0845C29.5672 26.0649 30.6868 25.4419 31.3539 24.419C32.0212 23.396 32.1504 22.1043 31.6994 20.9656C31.2486 19.8269 30.2753 18.9871 29.0975 18.7205L29.1021 18.7074Z"
                        fill="#45C49C"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_3308_397">
                        <rect width="44" height="44" rx="12" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>{" "}
                </div>
                <div className="flex flex-col max-w-sm pl-4 pr-10">
                  <p className="text-sm text-black font-bold max-w-0.5">
                    Brent Rodriguez
                  </p>
                  <p className="text-sm text-gray-400 font-medium">
                    brent@gmail.com
                  </p>
                </div>
                <div className="icon">
                  <svg
                    width="51"
                    height="50"
                    viewBox="0 0 51 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="1"
                      y="0.5"
                      width="49"
                      height="49"
                      rx="24.5"
                      fill="white"
                    />
                    <rect
                      x="1"
                      y="0.5"
                      width="49"
                      height="49"
                      rx="24.5"
                      stroke="#EAEEF4"
                    />
                    <path
                      d="M32.6538 32.9999H18.3462C18.0203 32.9999 17.75 32.7279 17.75 32.4C17.75 32.072 18.0203 31.8 18.3462 31.8H32.6538C32.9797 31.8 33.25 32.072 33.25 32.4C33.25 32.7279 32.9797 32.9999 32.6538 32.9999Z"
                      fill="#061B2E"
                    />
                    <path
                      d="M31.08 18.1851C29.5379 16.6332 28.0277 16.5932 26.4459 18.1851L25.4841 19.153C25.4046 19.233 25.3728 19.361 25.4046 19.473C26.0087 21.5928 27.6938 23.2887 29.8003 23.8966C29.8321 23.9046 29.8638 23.9126 29.8956 23.9126C29.9831 23.9126 30.0626 23.8806 30.1262 23.8166L31.08 22.8487C31.8669 22.0648 32.2485 21.3048 32.2485 20.5369C32.2564 19.7449 31.8749 18.977 31.08 18.1851Z"
                      fill="#061B2E"
                    />
                    <path
                      d="M28.3695 24.6246C28.139 24.5126 27.9164 24.4006 27.7018 24.2726C27.5269 24.1686 27.36 24.0566 27.1931 23.9366C27.0579 23.8486 26.899 23.7206 26.7479 23.5926C26.7321 23.5846 26.6764 23.5366 26.6128 23.4727C26.3505 23.2487 26.0564 22.9607 25.7941 22.6407C25.7703 22.6247 25.7305 22.5687 25.6749 22.4967C25.5954 22.4007 25.4603 22.2407 25.341 22.0568C25.2456 21.9368 25.1344 21.7608 25.031 21.5848C24.9038 21.3688 24.7926 21.1528 24.6813 20.9288C24.6644 20.8925 24.6482 20.8564 24.6323 20.8205C24.515 20.5539 24.1696 20.4759 23.9647 20.6821L19.4113 25.2645C19.3079 25.3685 19.2126 25.5685 19.1887 25.7045L18.7595 28.7682C18.68 29.3122 18.831 29.8242 19.1649 30.1681C19.451 30.4481 19.8485 30.6001 20.2777 30.6001C20.3731 30.6001 20.4685 30.5921 20.5638 30.5761L23.6162 30.1441C23.7592 30.1201 23.9579 30.0241 24.0533 29.9202L28.601 25.3435C28.8074 25.1358 28.7295 24.7795 28.4612 24.6642C28.431 24.6513 28.4004 24.6381 28.3695 24.6246Z"
                      fill="#061B2E"
                    />
                  </svg>{" "}
                </div>
              </div>
              <hr />
              <div className="flex flex-col items-start ">
                <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                  Employee ID
                </h4>
                <p className="px-2 py-0 text-sm text-black font-bold">
                  12227389
                </p>
              </div>
              <div className="flex flex-col items-start py-4 ">
                <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                  Created
                </h4>
                <p className="px-2 py-0 text-sm text-black font-bold">
                  Nov 22, 2024
                </p>
              </div>
            </div>

            <div class="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow ">
              <div className="flex items-center justify-start pb-2">
                <div className="svg">
                  <svg
                    width="44"
                    height="44"
                    viewBox="0 0 44 44"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_3308_397)">
                      <rect width="44" height="44" rx="12" fill="#EBF9F5" />
                      <path
                        d="M29.1021 18.7074C28.8792 16.2798 27.4757 14.1273 25.3642 12.9745C23.2525 11.8217 20.7135 11.8217 18.6021 12.9745C16.4907 14.1275 15.0871 16.28 14.8642 18.7074C13.7548 18.9472 12.8175 19.6968 12.3261 20.7368C11.8348 21.7768 11.8451 22.9898 12.3541 24.021C12.8629 25.0522 13.813 25.7853 14.9263 26.0056C15.2016 27.7085 16.0621 29.2566 17.3544 30.3744C18.6467 31.4922 20.287 32.1071 21.9834 32.1099H23.0173C23.6803 32.1099 24.3161 31.8418 24.7849 31.3649C25.2537 30.8881 25.5169 30.2412 25.5169 29.5667C25.5169 28.8921 25.2537 28.2452 24.7849 27.7682C24.3161 27.2913 23.6803 27.0234 23.0173 27.0234C22.3544 27.0234 21.7186 27.2913 21.2498 27.7682C20.781 28.2452 20.5176 28.8921 20.5176 29.5667V30.3346C19.4105 30.026 18.4227 29.3801 17.687 28.4834C16.9513 27.5868 16.5031 26.4826 16.4025 25.3192C16.4775 21.1322 16.4825 19.7961 16.3845 19.2701H16.3843C16.407 17.2351 17.495 15.3668 19.2386 14.369C20.9823 13.3713 23.1167 13.3959 24.8379 14.4335C26.559 15.471 27.6051 17.3639 27.5826 19.3991V19.4438C27.4715 25.4928 27.5181 25.5506 27.8024 25.8479H27.8022C27.9505 25.9987 28.1511 26.0838 28.3607 26.0845C29.5672 26.0649 30.6868 25.4419 31.3539 24.419C32.0212 23.396 32.1504 22.1043 31.6994 20.9656C31.2486 19.8269 30.2753 18.9871 29.0975 18.7205L29.1021 18.7074Z"
                        fill="#45C49C"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_3308_397">
                        <rect width="44" height="44" rx="12" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>{" "}
                </div>
                <div className="flex flex-col max-w-sm pl-4 pr-10">
                  <p className="text-sm text-black font-bold max-w-0.5">
                    Brent Rodriguez
                  </p>
                  <p className="text-sm text-gray-400 font-medium">
                    brent@gmail.com
                  </p>
                </div>
                <div className="icon">
                  <svg
                    width="51"
                    height="50"
                    viewBox="0 0 51 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="1"
                      y="0.5"
                      width="49"
                      height="49"
                      rx="24.5"
                      fill="white"
                    />
                    <rect
                      x="1"
                      y="0.5"
                      width="49"
                      height="49"
                      rx="24.5"
                      stroke="#EAEEF4"
                    />
                    <path
                      d="M32.6538 32.9999H18.3462C18.0203 32.9999 17.75 32.7279 17.75 32.4C17.75 32.072 18.0203 31.8 18.3462 31.8H32.6538C32.9797 31.8 33.25 32.072 33.25 32.4C33.25 32.7279 32.9797 32.9999 32.6538 32.9999Z"
                      fill="#061B2E"
                    />
                    <path
                      d="M31.08 18.1851C29.5379 16.6332 28.0277 16.5932 26.4459 18.1851L25.4841 19.153C25.4046 19.233 25.3728 19.361 25.4046 19.473C26.0087 21.5928 27.6938 23.2887 29.8003 23.8966C29.8321 23.9046 29.8638 23.9126 29.8956 23.9126C29.9831 23.9126 30.0626 23.8806 30.1262 23.8166L31.08 22.8487C31.8669 22.0648 32.2485 21.3048 32.2485 20.5369C32.2564 19.7449 31.8749 18.977 31.08 18.1851Z"
                      fill="#061B2E"
                    />
                    <path
                      d="M28.3695 24.6246C28.139 24.5126 27.9164 24.4006 27.7018 24.2726C27.5269 24.1686 27.36 24.0566 27.1931 23.9366C27.0579 23.8486 26.899 23.7206 26.7479 23.5926C26.7321 23.5846 26.6764 23.5366 26.6128 23.4727C26.3505 23.2487 26.0564 22.9607 25.7941 22.6407C25.7703 22.6247 25.7305 22.5687 25.6749 22.4967C25.5954 22.4007 25.4603 22.2407 25.341 22.0568C25.2456 21.9368 25.1344 21.7608 25.031 21.5848C24.9038 21.3688 24.7926 21.1528 24.6813 20.9288C24.6644 20.8925 24.6482 20.8564 24.6323 20.8205C24.515 20.5539 24.1696 20.4759 23.9647 20.6821L19.4113 25.2645C19.3079 25.3685 19.2126 25.5685 19.1887 25.7045L18.7595 28.7682C18.68 29.3122 18.831 29.8242 19.1649 30.1681C19.451 30.4481 19.8485 30.6001 20.2777 30.6001C20.3731 30.6001 20.4685 30.5921 20.5638 30.5761L23.6162 30.1441C23.7592 30.1201 23.9579 30.0241 24.0533 29.9202L28.601 25.3435C28.8074 25.1358 28.7295 24.7795 28.4612 24.6642C28.431 24.6513 28.4004 24.6381 28.3695 24.6246Z"
                      fill="#061B2E"
                    />
                  </svg>{" "}
                </div>
              </div>
              <hr />
              <div className="flex flex-col items-start ">
                <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                  Employee ID
                </h4>
                <p className="px-2 py-0 text-sm text-black font-bold">
                  12227389
                </p>
              </div>
              <div className="flex flex-col items-start py-4 ">
                <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                  Created
                </h4>
                <p className="px-2 py-0 text-sm text-black font-bold">
                  Nov 22, 2024
                </p>
              </div>
            </div>
            <div class="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow ">
              <div className="flex items-center justify-start pb-2">
                <div className="svg">
                  <svg
                    width="44"
                    height="44"
                    viewBox="0 0 44 44"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_3308_397)">
                      <rect width="44" height="44" rx="12" fill="#EBF9F5" />
                      <path
                        d="M29.1021 18.7074C28.8792 16.2798 27.4757 14.1273 25.3642 12.9745C23.2525 11.8217 20.7135 11.8217 18.6021 12.9745C16.4907 14.1275 15.0871 16.28 14.8642 18.7074C13.7548 18.9472 12.8175 19.6968 12.3261 20.7368C11.8348 21.7768 11.8451 22.9898 12.3541 24.021C12.8629 25.0522 13.813 25.7853 14.9263 26.0056C15.2016 27.7085 16.0621 29.2566 17.3544 30.3744C18.6467 31.4922 20.287 32.1071 21.9834 32.1099H23.0173C23.6803 32.1099 24.3161 31.8418 24.7849 31.3649C25.2537 30.8881 25.5169 30.2412 25.5169 29.5667C25.5169 28.8921 25.2537 28.2452 24.7849 27.7682C24.3161 27.2913 23.6803 27.0234 23.0173 27.0234C22.3544 27.0234 21.7186 27.2913 21.2498 27.7682C20.781 28.2452 20.5176 28.8921 20.5176 29.5667V30.3346C19.4105 30.026 18.4227 29.3801 17.687 28.4834C16.9513 27.5868 16.5031 26.4826 16.4025 25.3192C16.4775 21.1322 16.4825 19.7961 16.3845 19.2701H16.3843C16.407 17.2351 17.495 15.3668 19.2386 14.369C20.9823 13.3713 23.1167 13.3959 24.8379 14.4335C26.559 15.471 27.6051 17.3639 27.5826 19.3991V19.4438C27.4715 25.4928 27.5181 25.5506 27.8024 25.8479H27.8022C27.9505 25.9987 28.1511 26.0838 28.3607 26.0845C29.5672 26.0649 30.6868 25.4419 31.3539 24.419C32.0212 23.396 32.1504 22.1043 31.6994 20.9656C31.2486 19.8269 30.2753 18.9871 29.0975 18.7205L29.1021 18.7074Z"
                        fill="#45C49C"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_3308_397">
                        <rect width="44" height="44" rx="12" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>{" "}
                </div>
                <div className="flex flex-col max-w-sm pl-4 pr-10">
                  <p className="text-sm text-black font-bold max-w-0.5">
                    Brent Rodriguez
                  </p>
                  <p className="text-sm text-gray-400 font-medium">
                    brent@gmail.com
                  </p>
                </div>
                <div className="icon">
                  <svg
                    width="51"
                    height="50"
                    viewBox="0 0 51 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="1"
                      y="0.5"
                      width="49"
                      height="49"
                      rx="24.5"
                      fill="white"
                    />
                    <rect
                      x="1"
                      y="0.5"
                      width="49"
                      height="49"
                      rx="24.5"
                      stroke="#EAEEF4"
                    />
                    <path
                      d="M32.6538 32.9999H18.3462C18.0203 32.9999 17.75 32.7279 17.75 32.4C17.75 32.072 18.0203 31.8 18.3462 31.8H32.6538C32.9797 31.8 33.25 32.072 33.25 32.4C33.25 32.7279 32.9797 32.9999 32.6538 32.9999Z"
                      fill="#061B2E"
                    />
                    <path
                      d="M31.08 18.1851C29.5379 16.6332 28.0277 16.5932 26.4459 18.1851L25.4841 19.153C25.4046 19.233 25.3728 19.361 25.4046 19.473C26.0087 21.5928 27.6938 23.2887 29.8003 23.8966C29.8321 23.9046 29.8638 23.9126 29.8956 23.9126C29.9831 23.9126 30.0626 23.8806 30.1262 23.8166L31.08 22.8487C31.8669 22.0648 32.2485 21.3048 32.2485 20.5369C32.2564 19.7449 31.8749 18.977 31.08 18.1851Z"
                      fill="#061B2E"
                    />
                    <path
                      d="M28.3695 24.6246C28.139 24.5126 27.9164 24.4006 27.7018 24.2726C27.5269 24.1686 27.36 24.0566 27.1931 23.9366C27.0579 23.8486 26.899 23.7206 26.7479 23.5926C26.7321 23.5846 26.6764 23.5366 26.6128 23.4727C26.3505 23.2487 26.0564 22.9607 25.7941 22.6407C25.7703 22.6247 25.7305 22.5687 25.6749 22.4967C25.5954 22.4007 25.4603 22.2407 25.341 22.0568C25.2456 21.9368 25.1344 21.7608 25.031 21.5848C24.9038 21.3688 24.7926 21.1528 24.6813 20.9288C24.6644 20.8925 24.6482 20.8564 24.6323 20.8205C24.515 20.5539 24.1696 20.4759 23.9647 20.6821L19.4113 25.2645C19.3079 25.3685 19.2126 25.5685 19.1887 25.7045L18.7595 28.7682C18.68 29.3122 18.831 29.8242 19.1649 30.1681C19.451 30.4481 19.8485 30.6001 20.2777 30.6001C20.3731 30.6001 20.4685 30.5921 20.5638 30.5761L23.6162 30.1441C23.7592 30.1201 23.9579 30.0241 24.0533 29.9202L28.601 25.3435C28.8074 25.1358 28.7295 24.7795 28.4612 24.6642C28.431 24.6513 28.4004 24.6381 28.3695 24.6246Z"
                      fill="#061B2E"
                    />
                  </svg>{" "}
                </div>
              </div>
              <hr />
              <div className="flex flex-col items-start ">
                <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                  Employee ID
                </h4>
                <p className="px-2 py-0 text-sm text-black font-bold">
                  12227389
                </p>
              </div>
              <div className="flex flex-col items-start py-4 ">
                <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                  Created
                </h4>
                <p className="px-2 py-0 text-sm text-black font-bold">
                  Nov 22, 2024
                </p>
              </div>
            </div>
            <div class="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow ">
              <div className="flex items-center justify-start pb-2">
                <div className="svg">
                  <svg
                    width="44"
                    height="44"
                    viewBox="0 0 44 44"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_3308_397)">
                      <rect width="44" height="44" rx="12" fill="#EBF9F5" />
                      <path
                        d="M29.1021 18.7074C28.8792 16.2798 27.4757 14.1273 25.3642 12.9745C23.2525 11.8217 20.7135 11.8217 18.6021 12.9745C16.4907 14.1275 15.0871 16.28 14.8642 18.7074C13.7548 18.9472 12.8175 19.6968 12.3261 20.7368C11.8348 21.7768 11.8451 22.9898 12.3541 24.021C12.8629 25.0522 13.813 25.7853 14.9263 26.0056C15.2016 27.7085 16.0621 29.2566 17.3544 30.3744C18.6467 31.4922 20.287 32.1071 21.9834 32.1099H23.0173C23.6803 32.1099 24.3161 31.8418 24.7849 31.3649C25.2537 30.8881 25.5169 30.2412 25.5169 29.5667C25.5169 28.8921 25.2537 28.2452 24.7849 27.7682C24.3161 27.2913 23.6803 27.0234 23.0173 27.0234C22.3544 27.0234 21.7186 27.2913 21.2498 27.7682C20.781 28.2452 20.5176 28.8921 20.5176 29.5667V30.3346C19.4105 30.026 18.4227 29.3801 17.687 28.4834C16.9513 27.5868 16.5031 26.4826 16.4025 25.3192C16.4775 21.1322 16.4825 19.7961 16.3845 19.2701H16.3843C16.407 17.2351 17.495 15.3668 19.2386 14.369C20.9823 13.3713 23.1167 13.3959 24.8379 14.4335C26.559 15.471 27.6051 17.3639 27.5826 19.3991V19.4438C27.4715 25.4928 27.5181 25.5506 27.8024 25.8479H27.8022C27.9505 25.9987 28.1511 26.0838 28.3607 26.0845C29.5672 26.0649 30.6868 25.4419 31.3539 24.419C32.0212 23.396 32.1504 22.1043 31.6994 20.9656C31.2486 19.8269 30.2753 18.9871 29.0975 18.7205L29.1021 18.7074Z"
                        fill="#45C49C"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_3308_397">
                        <rect width="44" height="44" rx="12" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>{" "}
                </div>
                <div className="flex flex-col max-w-sm pl-4 pr-10">
                  <p className="text-sm text-black font-bold max-w-0.5">
                    Brent Rodriguez
                  </p>
                  <p className="text-sm text-gray-400 font-medium">
                    brent@gmail.com
                  </p>
                </div>
                <div className="icon">
                  <svg
                    width="51"
                    height="50"
                    viewBox="0 0 51 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="1"
                      y="0.5"
                      width="49"
                      height="49"
                      rx="24.5"
                      fill="white"
                    />
                    <rect
                      x="1"
                      y="0.5"
                      width="49"
                      height="49"
                      rx="24.5"
                      stroke="#EAEEF4"
                    />
                    <path
                      d="M32.6538 32.9999H18.3462C18.0203 32.9999 17.75 32.7279 17.75 32.4C17.75 32.072 18.0203 31.8 18.3462 31.8H32.6538C32.9797 31.8 33.25 32.072 33.25 32.4C33.25 32.7279 32.9797 32.9999 32.6538 32.9999Z"
                      fill="#061B2E"
                    />
                    <path
                      d="M31.08 18.1851C29.5379 16.6332 28.0277 16.5932 26.4459 18.1851L25.4841 19.153C25.4046 19.233 25.3728 19.361 25.4046 19.473C26.0087 21.5928 27.6938 23.2887 29.8003 23.8966C29.8321 23.9046 29.8638 23.9126 29.8956 23.9126C29.9831 23.9126 30.0626 23.8806 30.1262 23.8166L31.08 22.8487C31.8669 22.0648 32.2485 21.3048 32.2485 20.5369C32.2564 19.7449 31.8749 18.977 31.08 18.1851Z"
                      fill="#061B2E"
                    />
                    <path
                      d="M28.3695 24.6246C28.139 24.5126 27.9164 24.4006 27.7018 24.2726C27.5269 24.1686 27.36 24.0566 27.1931 23.9366C27.0579 23.8486 26.899 23.7206 26.7479 23.5926C26.7321 23.5846 26.6764 23.5366 26.6128 23.4727C26.3505 23.2487 26.0564 22.9607 25.7941 22.6407C25.7703 22.6247 25.7305 22.5687 25.6749 22.4967C25.5954 22.4007 25.4603 22.2407 25.341 22.0568C25.2456 21.9368 25.1344 21.7608 25.031 21.5848C24.9038 21.3688 24.7926 21.1528 24.6813 20.9288C24.6644 20.8925 24.6482 20.8564 24.6323 20.8205C24.515 20.5539 24.1696 20.4759 23.9647 20.6821L19.4113 25.2645C19.3079 25.3685 19.2126 25.5685 19.1887 25.7045L18.7595 28.7682C18.68 29.3122 18.831 29.8242 19.1649 30.1681C19.451 30.4481 19.8485 30.6001 20.2777 30.6001C20.3731 30.6001 20.4685 30.5921 20.5638 30.5761L23.6162 30.1441C23.7592 30.1201 23.9579 30.0241 24.0533 29.9202L28.601 25.3435C28.8074 25.1358 28.7295 24.7795 28.4612 24.6642C28.431 24.6513 28.4004 24.6381 28.3695 24.6246Z"
                      fill="#061B2E"
                    />
                  </svg>{" "}
                </div>
              </div>
              <hr />
              <div className="flex flex-col items-start ">
                <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                  Employee ID
                </h4>
                <p className="px-2 py-0 text-sm text-black font-bold">
                  12227389
                </p>
              </div>
              <div className="flex flex-col items-start py-4 ">
                <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                  Created
                </h4>
                <p className="px-2 py-0 text-sm text-black font-bold">
                  Nov 22, 2024
                </p>
              </div>
            </div>
            <div class="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow ">
              <div className="flex items-center justify-start pb-2">
                <div className="svg">
                  <svg
                    width="44"
                    height="44"
                    viewBox="0 0 44 44"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_3308_397)">
                      <rect width="44" height="44" rx="12" fill="#EBF9F5" />
                      <path
                        d="M29.1021 18.7074C28.8792 16.2798 27.4757 14.1273 25.3642 12.9745C23.2525 11.8217 20.7135 11.8217 18.6021 12.9745C16.4907 14.1275 15.0871 16.28 14.8642 18.7074C13.7548 18.9472 12.8175 19.6968 12.3261 20.7368C11.8348 21.7768 11.8451 22.9898 12.3541 24.021C12.8629 25.0522 13.813 25.7853 14.9263 26.0056C15.2016 27.7085 16.0621 29.2566 17.3544 30.3744C18.6467 31.4922 20.287 32.1071 21.9834 32.1099H23.0173C23.6803 32.1099 24.3161 31.8418 24.7849 31.3649C25.2537 30.8881 25.5169 30.2412 25.5169 29.5667C25.5169 28.8921 25.2537 28.2452 24.7849 27.7682C24.3161 27.2913 23.6803 27.0234 23.0173 27.0234C22.3544 27.0234 21.7186 27.2913 21.2498 27.7682C20.781 28.2452 20.5176 28.8921 20.5176 29.5667V30.3346C19.4105 30.026 18.4227 29.3801 17.687 28.4834C16.9513 27.5868 16.5031 26.4826 16.4025 25.3192C16.4775 21.1322 16.4825 19.7961 16.3845 19.2701H16.3843C16.407 17.2351 17.495 15.3668 19.2386 14.369C20.9823 13.3713 23.1167 13.3959 24.8379 14.4335C26.559 15.471 27.6051 17.3639 27.5826 19.3991V19.4438C27.4715 25.4928 27.5181 25.5506 27.8024 25.8479H27.8022C27.9505 25.9987 28.1511 26.0838 28.3607 26.0845C29.5672 26.0649 30.6868 25.4419 31.3539 24.419C32.0212 23.396 32.1504 22.1043 31.6994 20.9656C31.2486 19.8269 30.2753 18.9871 29.0975 18.7205L29.1021 18.7074Z"
                        fill="#45C49C"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_3308_397">
                        <rect width="44" height="44" rx="12" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>{" "}
                </div>
                <div className="flex flex-col max-w-sm pl-4 pr-10">
                  <p className="text-sm text-black font-bold max-w-0.5">
                    Brent Rodriguez
                  </p>
                  <p className="text-sm text-gray-400 font-medium">
                    brent@gmail.com
                  </p>
                </div>
                <div className="icon">
                  <svg
                    width="51"
                    height="50"
                    viewBox="0 0 51 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="1"
                      y="0.5"
                      width="49"
                      height="49"
                      rx="24.5"
                      fill="white"
                    />
                    <rect
                      x="1"
                      y="0.5"
                      width="49"
                      height="49"
                      rx="24.5"
                      stroke="#EAEEF4"
                    />
                    <path
                      d="M32.6538 32.9999H18.3462C18.0203 32.9999 17.75 32.7279 17.75 32.4C17.75 32.072 18.0203 31.8 18.3462 31.8H32.6538C32.9797 31.8 33.25 32.072 33.25 32.4C33.25 32.7279 32.9797 32.9999 32.6538 32.9999Z"
                      fill="#061B2E"
                    />
                    <path
                      d="M31.08 18.1851C29.5379 16.6332 28.0277 16.5932 26.4459 18.1851L25.4841 19.153C25.4046 19.233 25.3728 19.361 25.4046 19.473C26.0087 21.5928 27.6938 23.2887 29.8003 23.8966C29.8321 23.9046 29.8638 23.9126 29.8956 23.9126C29.9831 23.9126 30.0626 23.8806 30.1262 23.8166L31.08 22.8487C31.8669 22.0648 32.2485 21.3048 32.2485 20.5369C32.2564 19.7449 31.8749 18.977 31.08 18.1851Z"
                      fill="#061B2E"
                    />
                    <path
                      d="M28.3695 24.6246C28.139 24.5126 27.9164 24.4006 27.7018 24.2726C27.5269 24.1686 27.36 24.0566 27.1931 23.9366C27.0579 23.8486 26.899 23.7206 26.7479 23.5926C26.7321 23.5846 26.6764 23.5366 26.6128 23.4727C26.3505 23.2487 26.0564 22.9607 25.7941 22.6407C25.7703 22.6247 25.7305 22.5687 25.6749 22.4967C25.5954 22.4007 25.4603 22.2407 25.341 22.0568C25.2456 21.9368 25.1344 21.7608 25.031 21.5848C24.9038 21.3688 24.7926 21.1528 24.6813 20.9288C24.6644 20.8925 24.6482 20.8564 24.6323 20.8205C24.515 20.5539 24.1696 20.4759 23.9647 20.6821L19.4113 25.2645C19.3079 25.3685 19.2126 25.5685 19.1887 25.7045L18.7595 28.7682C18.68 29.3122 18.831 29.8242 19.1649 30.1681C19.451 30.4481 19.8485 30.6001 20.2777 30.6001C20.3731 30.6001 20.4685 30.5921 20.5638 30.5761L23.6162 30.1441C23.7592 30.1201 23.9579 30.0241 24.0533 29.9202L28.601 25.3435C28.8074 25.1358 28.7295 24.7795 28.4612 24.6642C28.431 24.6513 28.4004 24.6381 28.3695 24.6246Z"
                      fill="#061B2E"
                    />
                  </svg>{" "}
                </div>
              </div>
              <hr />
              <div className="flex flex-col items-start ">
                <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                  Employee ID
                </h4>
                <p className="px-2 py-0 text-sm text-black font-bold">
                  12227389
                </p>
              </div>
              <div className="flex flex-col items-start py-4 ">
                <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                  Created
                </h4>
                <p className="px-2 py-0 text-sm text-black font-bold">
                  Nov 22, 2024
                </p>
              </div>
            </div>
            <div class="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow ">
              <div className="flex items-center justify-start pb-2">
                <div className="svg">
                  <svg
                    width="44"
                    height="44"
                    viewBox="0 0 44 44"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_3308_397)">
                      <rect width="44" height="44" rx="12" fill="#EBF9F5" />
                      <path
                        d="M29.1021 18.7074C28.8792 16.2798 27.4757 14.1273 25.3642 12.9745C23.2525 11.8217 20.7135 11.8217 18.6021 12.9745C16.4907 14.1275 15.0871 16.28 14.8642 18.7074C13.7548 18.9472 12.8175 19.6968 12.3261 20.7368C11.8348 21.7768 11.8451 22.9898 12.3541 24.021C12.8629 25.0522 13.813 25.7853 14.9263 26.0056C15.2016 27.7085 16.0621 29.2566 17.3544 30.3744C18.6467 31.4922 20.287 32.1071 21.9834 32.1099H23.0173C23.6803 32.1099 24.3161 31.8418 24.7849 31.3649C25.2537 30.8881 25.5169 30.2412 25.5169 29.5667C25.5169 28.8921 25.2537 28.2452 24.7849 27.7682C24.3161 27.2913 23.6803 27.0234 23.0173 27.0234C22.3544 27.0234 21.7186 27.2913 21.2498 27.7682C20.781 28.2452 20.5176 28.8921 20.5176 29.5667V30.3346C19.4105 30.026 18.4227 29.3801 17.687 28.4834C16.9513 27.5868 16.5031 26.4826 16.4025 25.3192C16.4775 21.1322 16.4825 19.7961 16.3845 19.2701H16.3843C16.407 17.2351 17.495 15.3668 19.2386 14.369C20.9823 13.3713 23.1167 13.3959 24.8379 14.4335C26.559 15.471 27.6051 17.3639 27.5826 19.3991V19.4438C27.4715 25.4928 27.5181 25.5506 27.8024 25.8479H27.8022C27.9505 25.9987 28.1511 26.0838 28.3607 26.0845C29.5672 26.0649 30.6868 25.4419 31.3539 24.419C32.0212 23.396 32.1504 22.1043 31.6994 20.9656C31.2486 19.8269 30.2753 18.9871 29.0975 18.7205L29.1021 18.7074Z"
                        fill="#45C49C"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_3308_397">
                        <rect width="44" height="44" rx="12" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>{" "}
                </div>
                <div className="flex flex-col max-w-sm pl-4 pr-10">
                  <p className="text-sm text-black font-bold max-w-0.5">
                    Brent Rodriguez
                  </p>
                  <p className="text-sm text-gray-400 font-medium">
                    brent@gmail.com
                  </p>
                </div>
                <div className="icon">
                  <svg
                    width="51"
                    height="50"
                    viewBox="0 0 51 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="1"
                      y="0.5"
                      width="49"
                      height="49"
                      rx="24.5"
                      fill="white"
                    />
                    <rect
                      x="1"
                      y="0.5"
                      width="49"
                      height="49"
                      rx="24.5"
                      stroke="#EAEEF4"
                    />
                    <path
                      d="M32.6538 32.9999H18.3462C18.0203 32.9999 17.75 32.7279 17.75 32.4C17.75 32.072 18.0203 31.8 18.3462 31.8H32.6538C32.9797 31.8 33.25 32.072 33.25 32.4C33.25 32.7279 32.9797 32.9999 32.6538 32.9999Z"
                      fill="#061B2E"
                    />
                    <path
                      d="M31.08 18.1851C29.5379 16.6332 28.0277 16.5932 26.4459 18.1851L25.4841 19.153C25.4046 19.233 25.3728 19.361 25.4046 19.473C26.0087 21.5928 27.6938 23.2887 29.8003 23.8966C29.8321 23.9046 29.8638 23.9126 29.8956 23.9126C29.9831 23.9126 30.0626 23.8806 30.1262 23.8166L31.08 22.8487C31.8669 22.0648 32.2485 21.3048 32.2485 20.5369C32.2564 19.7449 31.8749 18.977 31.08 18.1851Z"
                      fill="#061B2E"
                    />
                    <path
                      d="M28.3695 24.6246C28.139 24.5126 27.9164 24.4006 27.7018 24.2726C27.5269 24.1686 27.36 24.0566 27.1931 23.9366C27.0579 23.8486 26.899 23.7206 26.7479 23.5926C26.7321 23.5846 26.6764 23.5366 26.6128 23.4727C26.3505 23.2487 26.0564 22.9607 25.7941 22.6407C25.7703 22.6247 25.7305 22.5687 25.6749 22.4967C25.5954 22.4007 25.4603 22.2407 25.341 22.0568C25.2456 21.9368 25.1344 21.7608 25.031 21.5848C24.9038 21.3688 24.7926 21.1528 24.6813 20.9288C24.6644 20.8925 24.6482 20.8564 24.6323 20.8205C24.515 20.5539 24.1696 20.4759 23.9647 20.6821L19.4113 25.2645C19.3079 25.3685 19.2126 25.5685 19.1887 25.7045L18.7595 28.7682C18.68 29.3122 18.831 29.8242 19.1649 30.1681C19.451 30.4481 19.8485 30.6001 20.2777 30.6001C20.3731 30.6001 20.4685 30.5921 20.5638 30.5761L23.6162 30.1441C23.7592 30.1201 23.9579 30.0241 24.0533 29.9202L28.601 25.3435C28.8074 25.1358 28.7295 24.7795 28.4612 24.6642C28.431 24.6513 28.4004 24.6381 28.3695 24.6246Z"
                      fill="#061B2E"
                    />
                  </svg>{" "}
                </div>
              </div>
              <hr />
              <div className="flex flex-col items-start ">
                <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                  Employee ID
                </h4>
                <p className="px-2 py-0 text-sm text-black font-bold">
                  12227389
                </p>
              </div>
              <div className="flex flex-col items-start py-4 ">
                <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                  Created
                </h4>
                <p className="px-2 py-0 text-sm text-black font-bold">
                  Nov 22, 2024
                </p>
              </div>
            </div>
            <div class="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow ">
              <div className="flex items-center justify-start pb-2">
                <div className="svg">
                  <svg
                    width="44"
                    height="44"
                    viewBox="0 0 44 44"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_3308_397)">
                      <rect width="44" height="44" rx="12" fill="#EBF9F5" />
                      <path
                        d="M29.1021 18.7074C28.8792 16.2798 27.4757 14.1273 25.3642 12.9745C23.2525 11.8217 20.7135 11.8217 18.6021 12.9745C16.4907 14.1275 15.0871 16.28 14.8642 18.7074C13.7548 18.9472 12.8175 19.6968 12.3261 20.7368C11.8348 21.7768 11.8451 22.9898 12.3541 24.021C12.8629 25.0522 13.813 25.7853 14.9263 26.0056C15.2016 27.7085 16.0621 29.2566 17.3544 30.3744C18.6467 31.4922 20.287 32.1071 21.9834 32.1099H23.0173C23.6803 32.1099 24.3161 31.8418 24.7849 31.3649C25.2537 30.8881 25.5169 30.2412 25.5169 29.5667C25.5169 28.8921 25.2537 28.2452 24.7849 27.7682C24.3161 27.2913 23.6803 27.0234 23.0173 27.0234C22.3544 27.0234 21.7186 27.2913 21.2498 27.7682C20.781 28.2452 20.5176 28.8921 20.5176 29.5667V30.3346C19.4105 30.026 18.4227 29.3801 17.687 28.4834C16.9513 27.5868 16.5031 26.4826 16.4025 25.3192C16.4775 21.1322 16.4825 19.7961 16.3845 19.2701H16.3843C16.407 17.2351 17.495 15.3668 19.2386 14.369C20.9823 13.3713 23.1167 13.3959 24.8379 14.4335C26.559 15.471 27.6051 17.3639 27.5826 19.3991V19.4438C27.4715 25.4928 27.5181 25.5506 27.8024 25.8479H27.8022C27.9505 25.9987 28.1511 26.0838 28.3607 26.0845C29.5672 26.0649 30.6868 25.4419 31.3539 24.419C32.0212 23.396 32.1504 22.1043 31.6994 20.9656C31.2486 19.8269 30.2753 18.9871 29.0975 18.7205L29.1021 18.7074Z"
                        fill="#45C49C"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_3308_397">
                        <rect width="44" height="44" rx="12" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>{" "}
                </div>
                <div className="flex flex-col max-w-sm pl-4 pr-10">
                  <p className="text-sm text-black font-bold max-w-0.5">
                    Brent Rodriguez
                  </p>
                  <p className="text-sm text-gray-400 font-medium">
                    brent@gmail.com
                  </p>
                </div>
                <div className="icon">
                  <svg
                    width="51"
                    height="50"
                    viewBox="0 0 51 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="1"
                      y="0.5"
                      width="49"
                      height="49"
                      rx="24.5"
                      fill="white"
                    />
                    <rect
                      x="1"
                      y="0.5"
                      width="49"
                      height="49"
                      rx="24.5"
                      stroke="#EAEEF4"
                    />
                    <path
                      d="M32.6538 32.9999H18.3462C18.0203 32.9999 17.75 32.7279 17.75 32.4C17.75 32.072 18.0203 31.8 18.3462 31.8H32.6538C32.9797 31.8 33.25 32.072 33.25 32.4C33.25 32.7279 32.9797 32.9999 32.6538 32.9999Z"
                      fill="#061B2E"
                    />
                    <path
                      d="M31.08 18.1851C29.5379 16.6332 28.0277 16.5932 26.4459 18.1851L25.4841 19.153C25.4046 19.233 25.3728 19.361 25.4046 19.473C26.0087 21.5928 27.6938 23.2887 29.8003 23.8966C29.8321 23.9046 29.8638 23.9126 29.8956 23.9126C29.9831 23.9126 30.0626 23.8806 30.1262 23.8166L31.08 22.8487C31.8669 22.0648 32.2485 21.3048 32.2485 20.5369C32.2564 19.7449 31.8749 18.977 31.08 18.1851Z"
                      fill="#061B2E"
                    />
                    <path
                      d="M28.3695 24.6246C28.139 24.5126 27.9164 24.4006 27.7018 24.2726C27.5269 24.1686 27.36 24.0566 27.1931 23.9366C27.0579 23.8486 26.899 23.7206 26.7479 23.5926C26.7321 23.5846 26.6764 23.5366 26.6128 23.4727C26.3505 23.2487 26.0564 22.9607 25.7941 22.6407C25.7703 22.6247 25.7305 22.5687 25.6749 22.4967C25.5954 22.4007 25.4603 22.2407 25.341 22.0568C25.2456 21.9368 25.1344 21.7608 25.031 21.5848C24.9038 21.3688 24.7926 21.1528 24.6813 20.9288C24.6644 20.8925 24.6482 20.8564 24.6323 20.8205C24.515 20.5539 24.1696 20.4759 23.9647 20.6821L19.4113 25.2645C19.3079 25.3685 19.2126 25.5685 19.1887 25.7045L18.7595 28.7682C18.68 29.3122 18.831 29.8242 19.1649 30.1681C19.451 30.4481 19.8485 30.6001 20.2777 30.6001C20.3731 30.6001 20.4685 30.5921 20.5638 30.5761L23.6162 30.1441C23.7592 30.1201 23.9579 30.0241 24.0533 29.9202L28.601 25.3435C28.8074 25.1358 28.7295 24.7795 28.4612 24.6642C28.431 24.6513 28.4004 24.6381 28.3695 24.6246Z"
                      fill="#061B2E"
                    />
                  </svg>{" "}
                </div>
              </div>
              <hr />
              <div className="flex flex-col items-start ">
                <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                  Employee ID
                </h4>
                <p className="px-2 py-0 text-sm text-black font-bold">
                  12227389
                </p>
              </div>
              <div className="flex flex-col items-start py-4 ">
                <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                  Created
                </h4>
                <p className="px-2 py-0 text-sm text-black font-bold">
                  Nov 22, 2024
                </p>
              </div>
            </div>
            <div class="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow ">
              <div className="flex items-center justify-start pb-2">
                <div className="svg">
                  <svg
                    width="44"
                    height="44"
                    viewBox="0 0 44 44"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_3308_397)">
                      <rect width="44" height="44" rx="12" fill="#EBF9F5" />
                      <path
                        d="M29.1021 18.7074C28.8792 16.2798 27.4757 14.1273 25.3642 12.9745C23.2525 11.8217 20.7135 11.8217 18.6021 12.9745C16.4907 14.1275 15.0871 16.28 14.8642 18.7074C13.7548 18.9472 12.8175 19.6968 12.3261 20.7368C11.8348 21.7768 11.8451 22.9898 12.3541 24.021C12.8629 25.0522 13.813 25.7853 14.9263 26.0056C15.2016 27.7085 16.0621 29.2566 17.3544 30.3744C18.6467 31.4922 20.287 32.1071 21.9834 32.1099H23.0173C23.6803 32.1099 24.3161 31.8418 24.7849 31.3649C25.2537 30.8881 25.5169 30.2412 25.5169 29.5667C25.5169 28.8921 25.2537 28.2452 24.7849 27.7682C24.3161 27.2913 23.6803 27.0234 23.0173 27.0234C22.3544 27.0234 21.7186 27.2913 21.2498 27.7682C20.781 28.2452 20.5176 28.8921 20.5176 29.5667V30.3346C19.4105 30.026 18.4227 29.3801 17.687 28.4834C16.9513 27.5868 16.5031 26.4826 16.4025 25.3192C16.4775 21.1322 16.4825 19.7961 16.3845 19.2701H16.3843C16.407 17.2351 17.495 15.3668 19.2386 14.369C20.9823 13.3713 23.1167 13.3959 24.8379 14.4335C26.559 15.471 27.6051 17.3639 27.5826 19.3991V19.4438C27.4715 25.4928 27.5181 25.5506 27.8024 25.8479H27.8022C27.9505 25.9987 28.1511 26.0838 28.3607 26.0845C29.5672 26.0649 30.6868 25.4419 31.3539 24.419C32.0212 23.396 32.1504 22.1043 31.6994 20.9656C31.2486 19.8269 30.2753 18.9871 29.0975 18.7205L29.1021 18.7074Z"
                        fill="#45C49C"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_3308_397">
                        <rect width="44" height="44" rx="12" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>{" "}
                </div>
                <div className="flex flex-col max-w-sm pl-4 pr-10">
                  <p className="text-sm text-black font-bold max-w-0.5">
                    Brent Rodriguez
                  </p>
                  <p className="text-sm text-gray-400 font-medium">
                    brent@gmail.com
                  </p>
                </div>
                <div className="icon">
                  <svg
                    width="51"
                    height="50"
                    viewBox="0 0 51 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="1"
                      y="0.5"
                      width="49"
                      height="49"
                      rx="24.5"
                      fill="white"
                    />
                    <rect
                      x="1"
                      y="0.5"
                      width="49"
                      height="49"
                      rx="24.5"
                      stroke="#EAEEF4"
                    />
                    <path
                      d="M32.6538 32.9999H18.3462C18.0203 32.9999 17.75 32.7279 17.75 32.4C17.75 32.072 18.0203 31.8 18.3462 31.8H32.6538C32.9797 31.8 33.25 32.072 33.25 32.4C33.25 32.7279 32.9797 32.9999 32.6538 32.9999Z"
                      fill="#061B2E"
                    />
                    <path
                      d="M31.08 18.1851C29.5379 16.6332 28.0277 16.5932 26.4459 18.1851L25.4841 19.153C25.4046 19.233 25.3728 19.361 25.4046 19.473C26.0087 21.5928 27.6938 23.2887 29.8003 23.8966C29.8321 23.9046 29.8638 23.9126 29.8956 23.9126C29.9831 23.9126 30.0626 23.8806 30.1262 23.8166L31.08 22.8487C31.8669 22.0648 32.2485 21.3048 32.2485 20.5369C32.2564 19.7449 31.8749 18.977 31.08 18.1851Z"
                      fill="#061B2E"
                    />
                    <path
                      d="M28.3695 24.6246C28.139 24.5126 27.9164 24.4006 27.7018 24.2726C27.5269 24.1686 27.36 24.0566 27.1931 23.9366C27.0579 23.8486 26.899 23.7206 26.7479 23.5926C26.7321 23.5846 26.6764 23.5366 26.6128 23.4727C26.3505 23.2487 26.0564 22.9607 25.7941 22.6407C25.7703 22.6247 25.7305 22.5687 25.6749 22.4967C25.5954 22.4007 25.4603 22.2407 25.341 22.0568C25.2456 21.9368 25.1344 21.7608 25.031 21.5848C24.9038 21.3688 24.7926 21.1528 24.6813 20.9288C24.6644 20.8925 24.6482 20.8564 24.6323 20.8205C24.515 20.5539 24.1696 20.4759 23.9647 20.6821L19.4113 25.2645C19.3079 25.3685 19.2126 25.5685 19.1887 25.7045L18.7595 28.7682C18.68 29.3122 18.831 29.8242 19.1649 30.1681C19.451 30.4481 19.8485 30.6001 20.2777 30.6001C20.3731 30.6001 20.4685 30.5921 20.5638 30.5761L23.6162 30.1441C23.7592 30.1201 23.9579 30.0241 24.0533 29.9202L28.601 25.3435C28.8074 25.1358 28.7295 24.7795 28.4612 24.6642C28.431 24.6513 28.4004 24.6381 28.3695 24.6246Z"
                      fill="#061B2E"
                    />
                  </svg>{" "}
                </div>
              </div>
              <hr />
              <div className="flex flex-col items-start ">
                <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                  Employee ID
                </h4>
                <p className="px-2 py-0 text-sm text-black font-bold">
                  12227389
                </p>
              </div>
              <div className="flex flex-col items-start py-4 ">
                <h4 className="px-2 pt-2 text-sm text-gray-400 font-medium">
                  Created
                </h4>
                <p className="px-2 py-0 text-sm text-black font-bold">
                  Nov 22, 2024
                </p>
              </div>
            </div>
          </div>
        </section>
      </Container>
    </Layout>
  )
}

export default TicketList